/**
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { useEffect, useRef,  memo } from "react";
import { useLiveAPIContext } from "../../contexts/LiveAPIContext";


function AltairComponent() {
  const { setConfig } = useLiveAPIContext();

  useEffect(() => {
    setConfig({
      model: "models/gemini-2.0-flash-exp",
      generationConfig: {
        responseModalities: "audio",
        speechConfig: {
          voiceConfig: { prebuiltVoiceConfig: { voiceName: "Aoede" } },
        },
      },
      systemInstruction: {
        parts: [
          {
            text: `You are a Hospital bot for Kasturba Hospital Manipal. 
          You can help queries related to following 
          1. Booking an appointment, 
          2. Details about Hospital Services and Specialties, 
          3. Help to receive the feedback from patients

          If user asks about booking an appointment, you should get following details from the user. Please assume the proper context and respond accordingly:
            1. Name and contact details of the patient
            2. Which doctor the patient wants to meet
            3. Date and time of the appointment

          If user asks details about Hospital Services and Specialties, you make a short answer based on following information: 
            Kasturbal Hospital Manipal provides services in Anesthesiology, Immunohematology & Transfusion Medicine, Cardio Vascular & Thoracic Surgery, Cardiology, Clinical Psychology, Pediatric Hematology and Oncology, ENT, Nephrology, Gastroenterology, Infectious Diseases, Orthopaedics, Neurology etc

          If user asks to receive the feedback, you should get a as much information as possible from like following details from the user, Please assume the proper context and respond accordingly, confirm the feedback be empathetic and thank the user for the feedback:
            1. Name of the patient
            2. What service the patient received, date & time and which doctor provided the service
            3. More context about the service 
            4. And Actual Feedback
            
          However, if the user asks about non-hospital related topics, you should respond with 
          "I am sorry, I can't help with that."`,
          },
        ],
      },
    });
  }, [setConfig]);

  const embedRef = useRef<HTMLDivElement>(null);

  return <div className="vega-embed" ref={embedRef} />;
}

export const Altair = memo(AltairComponent);
